export default __webpack_public_path__ + "static/media/addnew.c8498895.svg";